// extracted by mini-css-extract-plugin
module.exports = {"notAvailable":"ProfileNotAvailable_notAvailable__ojRe4"};